import { createApi } from '@reduxjs/toolkit/query/react';
import { apiBaseQuery } from './baseQuery';
import { errorTagTypes } from './handleErrorTags';

export type postLoginResponse = {
  accessToken: string;
  refreshToken: string;
  userName: string;
  roleId: number;
};

type postLoginRequest = {
  email: string;
  password: string;
};

type postPasswordResetEmailRequest = {
  email: string;
};

type putPasswordResetRequest = {
  newPassword: string;
  confirmNewPassword: string;
  passwordResetToken: string | null;
};

type RefreshTokenResponse = {
  accessToken: string;
};

export const loginApi = createApi({
  baseQuery: apiBaseQuery,
  tagTypes: errorTagTypes,
  endpoints: (builder) => ({
    postLogin: builder.mutation<postLoginResponse, postLoginRequest>({
      query: (request) => ({
        url: `auth/login`,
        method: 'POST',
        body: request,
      }),
    }),

    postPasswordResetEmail: builder.mutation<
      void,
      postPasswordResetEmailRequest
    >({
      query: (request) => ({
        url: `auth/password/send-password-reset-email`,
        method: 'POST',
        body: request,
      }),
    }),
    putPasswordReset: builder.mutation<void, putPasswordResetRequest>({
      query: (request) => ({
        url: `auth/password/reset`,
        method: 'PUT',
        body: request,
      }),
    }),

    refreshToken: builder.mutation<RefreshTokenResponse, string>({
      query: (token) => ({
        url: `/auth/access-token`,
        method: 'POST',
        body: {
          refreshToken: token,
        },
      }),
    }),
  }),
});

export const {
  usePostLoginMutation,
  usePostPasswordResetEmailMutation,
  usePutPasswordResetMutation,
} = loginApi;

export const refreshTokenApi = loginApi.endpoints.refreshToken;
